import { SkeletonBlock } from '../../SkeletonBlock/SkeletonBlock';
import { SkeletonCard } from '../common';

export function FirstBlock() {
  return (
    <SkeletonCard className="h-[212px] rounded-[16px] pb-[16px]">
      <SkeletonBlock className="h-[16px] w-[clamp(119px,30%,240px)]" variant="sunked" />

      <div className="mt-[18px] flex justify-around gap-x-[12px]">
        <SkeletonBlock className="h-[80px] w-[60px]" variant="sunked" />
        <SkeletonBlock className="h-[80px] w-[60px]" variant="sunked" />
      </div>

      <div className="mt-auto grid grid-cols-6 gap-x-[12px] gap-y-[9px]">
        {Array.from({ length: 12 }).map((_, i) => (
          <SkeletonBlock key={i} className="h-[16px]" variant="sunked" />
        ))}
      </div>
    </SkeletonCard>
  );
}
